/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type UserHistoryAroundTransferQueryVariables = {
    mobile: string;
    around: string;
    canReadBalance: boolean;
    canReadHistory: boolean;
    first: number;
    last: number;
};
export type UserHistoryAroundTransferQueryResponse = {
    readonly wallet: {
        readonly mobile: string;
        readonly balance?: string | undefined;
        readonly supportHistoryConnection?: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly __typename: string;
                    readonly id: string;
                    readonly whenEntered: string;
                    readonly isPending?: boolean | undefined;
                    readonly isCancelled?: boolean | undefined;
                    readonly summary?: string | null | undefined;
                    readonly amount?: string | undefined;
                    readonly balance?: string | undefined;
                    readonly transferId?: string | undefined;
                    readonly " $fragmentRefs": FragmentRefs<"PersonalHistoryEntry_entry">;
                };
            }>;
            readonly pageInfo: {
                readonly hasNextPage: boolean;
            };
        } | undefined;
    } | null;
};
export type UserHistoryAroundTransferQuery = {
    readonly response: UserHistoryAroundTransferQueryResponse;
    readonly variables: UserHistoryAroundTransferQueryVariables;
};



/*
query UserHistoryAroundTransferQuery(
  $mobile: String!
  $around: ID!
  $canReadBalance: Boolean!
  $canReadHistory: Boolean!
  $first: Int!
  $last: Int!
) {
  wallet(mobile: $mobile) {
    mobile
    balance @include(if: $canReadBalance)
    supportHistoryConnection(first: $first, last: $last, around: $around) @include(if: $canReadHistory) {
      edges {
        node {
          __typename
          id
          whenEntered
          ...PersonalHistoryEntry_entry
          ... on HistoryEntry {
            __isHistoryEntry: __typename
            isPending
            isCancelled
            summary
            amount
            balance @include(if: $canReadBalance)
            ... on TransferSentEntry {
              transferId
            }
            ... on TransferReceivedEntry {
              transferId
            }
            ... on MobileTransferEntry {
              __isMobileTransferEntry: __typename
              transferId
            }
          }
        }
      }
      pageInfo {
        hasNextPage
      }
    }
    id
  }
}

fragment AdjustmentEntry_tx on AdjustmentEntry {
  __typename
  description
  senderMobile
  recipientMobile
  ...HistoryEntry_entry
}

fragment BillPaymentEntry_tx on BillPaymentEntry {
  transferId
  senderMobile
  maybeTerminatedSenderMobile
  relatedTicket {
    status
    slackMessageUrl
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  billPayProblems {
    whenOpened
    billType
    status
    transactionId
  }
  amount
  billAccount
  billId
  billName
  isCancelled
  summary
  errorCode
  localizedErrMessage
  airtimeSms
  meterNumber
  ...HistoryEntry_entry
}

fragment BlockRecipient_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  recipientName
  recipientMobile
}

fragment ChangePayoutRecipient_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment ChangeRecipient_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  amount
  receiveAmount
  recipientMobile
  recipientName
}

fragment ChangeRemittanceRecipient_transfer on RemittanceTransferReceivedEntry {
  opaqueId
  senderName
  senderMobile
  amount
}

fragment FailedMerchantTransferEntry_tx on FailedMerchantTransferEntry {
  id
  whenEntered
  sendAmount
  receiveAmount
  isCancelled
  merchantId
  merchantName
  scamInvestigationFields {
    deviceId
    deviceModel
    deviceName
    userInterface
  }
}

fragment HistoryEntry_entry on HistoryEntry {
  __isHistoryEntry: __typename
  id
  whenEntered
  amount
  balance
  summary
  isPending
  isCancelled
  ... on SupportHistoryEntry {
    __isSupportHistoryEntry: __typename
    scamInvestigationFields {
      deviceId
      deviceModel
      deviceName
      userInterface
      agentMobile
    }
  }
  ... on AgentTransactionEntry {
    agentTransactionId
  }
  ... on TransferSentEntry {
    transferId
  }
}

fragment LoginLogoutEvent_tx on LoginLogoutEvent {
  id
  event
  whenEntered
  correspondingLoginTime
  scamInvestigationFields {
    deviceId
    deviceModel
    deviceName
  }
}

fragment PaymentCardTransferEntry_tx on PaymentCardTransferEntry {
  amount
  summary
  description
  transferId
  mobile
  baseReceiptFields {
    formatType
    label
    value
  }
  ...HistoryEntry_entry
}

fragment PayoutTransferEntry_tx on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  senderName
  recipientMobile
  isReversal
  ...HistoryEntry_entry
  ...SupportPayoutTransferReverse_transfer
  ...ChangePayoutRecipient_transfer
}

fragment PersonalHistoryEntry_entry on SupportHistoryEntry {
  __isSupportHistoryEntry: __typename
  __typename
  ...HistoryEntry_entry
  ...UserAtxEntry_tx
  ...BillPaymentEntry_tx
  ...UserLinkedAccountTransferB2WEntry_tx
  ...UserLinkedAccountTransferW2BEntry_tx
  ...PaymentCardTransferEntry_tx
  ...TransferReceivedEntry_tx
  ...TransferSentEntry_tx
  ...TransferSentReversalEntry_tx
  ...TransferReceivedReversalEntry_tx
  ...PayoutTransferEntry_tx
  ...PurchaseEntry_tx
  ...RemittanceTransferReceivedEntry_tx
  ...RemittanceTransferReversalEntry_tx
  ...AdjustmentEntry_tx
  ...LoginLogoutEvent_tx
  ...FailedMerchantTransferEntry_tx
  ...ReversalDisputeEntry_tx
}

fragment PurchaseEntry_tx on PurchaseEntry {
  senderMobile
  maybeTerminatedSenderMobile
  amount
  merchantId
  merchantName
  merchantCode
  merchantMobile
  promoUsed
  transferId
  isRefunded
  isRemote
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
  ...RefundPurchaseEntry_transfer
}

fragment RefundP2P_transfer on MobileTransferEntry {
  __isMobileTransferEntry: __typename
  id
  transferId
  sendAmount
  receiveAmount
  senderName
  senderMobile
  recipientName
  maybeTerminatedRecipientMobile
}

fragment RefundPurchaseEntry_transfer on PurchaseEntry {
  id
  transferId
  amount
  merchantName
}

fragment RemittanceTransferReceivedEntry_tx on RemittanceTransferReceivedEntry {
  id
  opaqueId
  description
  amount
  isPending
  isCancelled
  senderName
  senderMobile
  senderCountry
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
  ...RemittanceTransferRefund_transfer
  ...ChangeRemittanceRecipient_transfer
}

fragment RemittanceTransferRefund_transfer on RemittanceTransferReceivedEntry {
  opaqueId
  senderName
  senderMobile
  amount
}

fragment RemittanceTransferReversalEntry_tx on RemittanceTransferReversalEntry {
  id
  opaqueId
  description
  amount
  isPending
  senderName
  senderMobile
  senderCountry
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
}

fragment ReversalDisputeEntry_tx on ReversalDisputeEntry {
  __typename
  description
  isPending
  ledgerTransactionId
  originalTransferId
  ...HistoryEntry_entry
}

fragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {
  tcid
  amount
  senderOpaqueId
  sender: senderName
  maybeRecipientName: recipientName
  recipientMobile
  isReversal
}

fragment TransferReceivedEntry_tx on TransferReceivedEntry {
  transferId
  senderName
  senderMobile
  maybeTerminatedSenderMobile
  paymentBatchId
  recipientMobile
  receiveAmount
  ...HistoryEntry_entry
  ...ChangeRecipient_transfer
  ...RefundP2P_transfer
}

fragment TransferReceivedReversalEntry_tx on TransferReceivedReversalEntry {
  transferId
  description
  isPending
  isFreezingFunds
  ledgerTransactionId
  senderMobile
  sendAmount
  recipientMobile
  ...HistoryEntry_entry
}

fragment TransferSentEntry_tx on TransferSentEntry {
  transferId
  senderMobile
  recipientName
  recipientMobile
  maybeTerminatedRecipientMobile
  amount
  receiveAmount
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...ChangeRecipient_transfer
  ...RefundP2P_transfer
  ...BlockRecipient_transfer
  ...HistoryEntry_entry
}

fragment TransferSentReversalEntry_tx on TransferSentReversalEntry {
  transferId
  description
  isPending
  isFreezingFunds
  ledgerTransactionId
  senderMobile
  sendAmount
  ...HistoryEntry_entry
}

fragment UserAtxEntry_tx on AgentTransactionEntry {
  agentTransactionId
  isDeposit
  agentName
  agentId
  agentUfid
  customerMobile
  customerName
  maybeTerminatedCustomerMobile
  amount
  relatedTicket {
    whenOpened
    whenResolved
    status
    slackMessageUrl
    ticketType
    reference
  }
  scamReports {
    whenOpened
    whenResolved
    status
    transactionIds
  }
  ...HistoryEntry_entry
}

fragment UserLinkedAccountTransferB2WEntry_tx on UserLinkedAccountTransferB2WEntry {
  summary
  isCancelled
  partnerName
  liaTransferId
  errorCode
  errorMessage
  ...HistoryEntry_entry
}

fragment UserLinkedAccountTransferW2BEntry_tx on UserLinkedAccountTransferW2BEntry {
  summary
  isCancelled
  partnerName
  liaTransferId
  errorCode
  errorMessage
  ...HistoryEntry_entry
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "around"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadBalance"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "canReadHistory"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mobile"
},
v6 = [
  {
    "kind": "Variable",
    "name": "mobile",
    "variableName": "mobile"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobile",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "balance",
  "storageKey": null
},
v9 = {
  "condition": "canReadBalance",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v8/*: any*/)
  ]
},
v10 = [
  {
    "kind": "Variable",
    "name": "around",
    "variableName": "around"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenEntered",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPending",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCancelled",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transferId",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "TransferSentEntry",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "TransferReceivedEntry",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "MobileTransferEntry",
  "abstractKey": "__isMobileTransferEntry"
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceModel",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deviceName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userInterface",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agentTransactionId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenOpened",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "whenResolved",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackMessageUrl",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketShortInfo",
  "kind": "LinkedField",
  "name": "relatedTicket",
  "plural": false,
  "selections": [
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reference",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ScamReportTicket",
  "kind": "LinkedField",
  "name": "scamReports",
  "plural": true,
  "selections": [
    (v29/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionIds",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderMobile",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maybeTerminatedSenderMobile",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorCode",
  "storageKey": null
},
v38 = [
  (v16/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "partnerName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "liaTransferId",
    "storageKey": null
  },
  (v37/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "errorMessage",
    "storageKey": null
  }
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderName",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientMobile",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receiveAmount",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recipientName",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendAmount",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maybeTerminatedRecipientMobile",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFreezingFunds",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ledgerTransactionId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantId",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantName",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opaqueId",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "senderCountry",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserHistoryAroundTransferQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "condition": "canReadHistory",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "SupportHistoryConnection",
                "kind": "LinkedField",
                "name": "supportHistoryConnection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SupportHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "PersonalHistoryEntry_entry"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v9/*: any*/),
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/)
                            ],
                            "type": "HistoryEntry",
                            "abstractKey": "__isHistoryEntry"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserHistoryAroundTransferQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v12/*: any*/),
          (v9/*: any*/),
          {
            "condition": "canReadHistory",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "SupportHistoryConnection",
                "kind": "LinkedField",
                "name": "supportHistoryConnection",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SupportHistoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isSupportHistoryEntry"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              (v8/*: any*/),
                              (v16/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ScamInvestigationFields",
                                    "kind": "LinkedField",
                                    "name": "scamInvestigationFields",
                                    "plural": false,
                                    "selections": [
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "agentMobile",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "SupportHistoryEntry",
                                "abstractKey": "__isSupportHistoryEntry"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v28/*: any*/)
                                ],
                                "type": "AgentTransactionEntry",
                                "abstractKey": null
                              },
                              (v20/*: any*/),
                              (v21/*: any*/),
                              (v22/*: any*/)
                            ],
                            "type": "HistoryEntry",
                            "abstractKey": "__isHistoryEntry"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isDeposit",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "agentUfid",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerMobile",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "customerName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "maybeTerminatedCustomerMobile",
                                "storageKey": null
                              },
                              (v17/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/)
                            ],
                            "type": "AgentTransactionEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TicketShortInfo",
                                "kind": "LinkedField",
                                "name": "relatedTicket",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  (v32/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BillPayProblemTicket",
                                "kind": "LinkedField",
                                "name": "billPayProblems",
                                "plural": true,
                                "selections": [
                                  (v29/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billType",
                                    "storageKey": null
                                  },
                                  (v31/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "transactionId",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billAccount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "billName",
                                "storageKey": null
                              },
                              (v15/*: any*/),
                              (v16/*: any*/),
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "localizedErrMessage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "airtimeSms",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "meterNumber",
                                "storageKey": null
                              }
                            ],
                            "type": "BillPaymentEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v38/*: any*/),
                            "type": "UserLinkedAccountTransferB2WEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v38/*: any*/),
                            "type": "UserLinkedAccountTransferW2BEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              (v16/*: any*/),
                              (v39/*: any*/),
                              (v18/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReceiptField",
                                "kind": "LinkedField",
                                "name": "baseReceiptFields",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "formatType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "value",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "PaymentCardTransferEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v40/*: any*/),
                              (v35/*: any*/),
                              (v36/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "paymentBatchId",
                                "storageKey": null
                              },
                              (v41/*: any*/),
                              (v42/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v17/*: any*/),
                                  (v43/*: any*/),
                                  (v44/*: any*/),
                                  (v45/*: any*/)
                                ],
                                "type": "MobileTransferEntry",
                                "abstractKey": "__isMobileTransferEntry"
                              }
                            ],
                            "type": "TransferReceivedEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v35/*: any*/),
                              (v43/*: any*/),
                              (v41/*: any*/),
                              (v45/*: any*/),
                              (v17/*: any*/),
                              (v42/*: any*/),
                              (v33/*: any*/),
                              (v34/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v44/*: any*/),
                                  (v40/*: any*/)
                                ],
                                "type": "MobileTransferEntry",
                                "abstractKey": "__isMobileTransferEntry"
                              }
                            ],
                            "type": "TransferSentEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v39/*: any*/),
                              (v14/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v35/*: any*/),
                              (v44/*: any*/)
                            ],
                            "type": "TransferSentReversalEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v18/*: any*/),
                              (v39/*: any*/),
                              (v14/*: any*/),
                              (v46/*: any*/),
                              (v47/*: any*/),
                              (v35/*: any*/),
                              (v44/*: any*/),
                              (v41/*: any*/)
                            ],
                            "type": "TransferReceivedReversalEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "tcid",
                                "storageKey": null
                              },
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "senderOpaqueId",
                                "storageKey": null
                              },
                              (v40/*: any*/),
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isReversal",
                                "storageKey": null
                              },
                              {
                                "alias": "sender",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "senderName",
                                "storageKey": null
                              },
                              {
                                "alias": "maybeRecipientName",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "recipientName",
                                "storageKey": null
                              }
                            ],
                            "type": "PayoutTransferEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              (v36/*: any*/),
                              (v17/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "merchantCode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "merchantMobile",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "promoUsed",
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRefunded",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isRemote",
                                "storageKey": null
                              },
                              (v33/*: any*/),
                              (v34/*: any*/)
                            ],
                            "type": "PurchaseEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v50/*: any*/),
                              (v39/*: any*/),
                              (v17/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v40/*: any*/),
                              (v35/*: any*/),
                              (v51/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/)
                            ],
                            "type": "RemittanceTransferReceivedEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v50/*: any*/),
                              (v39/*: any*/),
                              (v17/*: any*/),
                              (v14/*: any*/),
                              (v40/*: any*/),
                              (v35/*: any*/),
                              (v51/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/)
                            ],
                            "type": "RemittanceTransferReversalEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v39/*: any*/),
                              (v35/*: any*/),
                              (v41/*: any*/)
                            ],
                            "type": "AdjustmentEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "event",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "correspondingLoginTime",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ScamInvestigationFields",
                                "kind": "LinkedField",
                                "name": "scamInvestigationFields",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "LoginLogoutEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v44/*: any*/),
                              (v42/*: any*/),
                              (v15/*: any*/),
                              (v48/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ScamInvestigationFields",
                                "kind": "LinkedField",
                                "name": "scamInvestigationFields",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "FailedMerchantTransferEntry",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v39/*: any*/),
                              (v14/*: any*/),
                              (v47/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "originalTransferId",
                                "storageKey": null
                              }
                            ],
                            "type": "ReversalDisputeEntry",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e7237be788e520ff2b05b8f8f0738a6",
    "id": null,
    "metadata": {},
    "name": "UserHistoryAroundTransferQuery",
    "operationKind": "query",
    "text": "query UserHistoryAroundTransferQuery(\n  $mobile: String!\n  $around: ID!\n  $canReadBalance: Boolean!\n  $canReadHistory: Boolean!\n  $first: Int!\n  $last: Int!\n) {\n  wallet(mobile: $mobile) {\n    mobile\n    balance @include(if: $canReadBalance)\n    supportHistoryConnection(first: $first, last: $last, around: $around) @include(if: $canReadHistory) {\n      edges {\n        node {\n          __typename\n          id\n          whenEntered\n          ...PersonalHistoryEntry_entry\n          ... on HistoryEntry {\n            __isHistoryEntry: __typename\n            isPending\n            isCancelled\n            summary\n            amount\n            balance @include(if: $canReadBalance)\n            ... on TransferSentEntry {\n              transferId\n            }\n            ... on TransferReceivedEntry {\n              transferId\n            }\n            ... on MobileTransferEntry {\n              __isMobileTransferEntry: __typename\n              transferId\n            }\n          }\n        }\n      }\n      pageInfo {\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment AdjustmentEntry_tx on AdjustmentEntry {\n  __typename\n  description\n  senderMobile\n  recipientMobile\n  ...HistoryEntry_entry\n}\n\nfragment BillPaymentEntry_tx on BillPaymentEntry {\n  transferId\n  senderMobile\n  maybeTerminatedSenderMobile\n  relatedTicket {\n    status\n    slackMessageUrl\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  billPayProblems {\n    whenOpened\n    billType\n    status\n    transactionId\n  }\n  amount\n  billAccount\n  billId\n  billName\n  isCancelled\n  summary\n  errorCode\n  localizedErrMessage\n  airtimeSms\n  meterNumber\n  ...HistoryEntry_entry\n}\n\nfragment BlockRecipient_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  recipientName\n  recipientMobile\n}\n\nfragment ChangePayoutRecipient_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment ChangeRecipient_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  amount\n  receiveAmount\n  recipientMobile\n  recipientName\n}\n\nfragment ChangeRemittanceRecipient_transfer on RemittanceTransferReceivedEntry {\n  opaqueId\n  senderName\n  senderMobile\n  amount\n}\n\nfragment FailedMerchantTransferEntry_tx on FailedMerchantTransferEntry {\n  id\n  whenEntered\n  sendAmount\n  receiveAmount\n  isCancelled\n  merchantId\n  merchantName\n  scamInvestigationFields {\n    deviceId\n    deviceModel\n    deviceName\n    userInterface\n  }\n}\n\nfragment HistoryEntry_entry on HistoryEntry {\n  __isHistoryEntry: __typename\n  id\n  whenEntered\n  amount\n  balance\n  summary\n  isPending\n  isCancelled\n  ... on SupportHistoryEntry {\n    __isSupportHistoryEntry: __typename\n    scamInvestigationFields {\n      deviceId\n      deviceModel\n      deviceName\n      userInterface\n      agentMobile\n    }\n  }\n  ... on AgentTransactionEntry {\n    agentTransactionId\n  }\n  ... on TransferSentEntry {\n    transferId\n  }\n}\n\nfragment LoginLogoutEvent_tx on LoginLogoutEvent {\n  id\n  event\n  whenEntered\n  correspondingLoginTime\n  scamInvestigationFields {\n    deviceId\n    deviceModel\n    deviceName\n  }\n}\n\nfragment PaymentCardTransferEntry_tx on PaymentCardTransferEntry {\n  amount\n  summary\n  description\n  transferId\n  mobile\n  baseReceiptFields {\n    formatType\n    label\n    value\n  }\n  ...HistoryEntry_entry\n}\n\nfragment PayoutTransferEntry_tx on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  senderName\n  recipientMobile\n  isReversal\n  ...HistoryEntry_entry\n  ...SupportPayoutTransferReverse_transfer\n  ...ChangePayoutRecipient_transfer\n}\n\nfragment PersonalHistoryEntry_entry on SupportHistoryEntry {\n  __isSupportHistoryEntry: __typename\n  __typename\n  ...HistoryEntry_entry\n  ...UserAtxEntry_tx\n  ...BillPaymentEntry_tx\n  ...UserLinkedAccountTransferB2WEntry_tx\n  ...UserLinkedAccountTransferW2BEntry_tx\n  ...PaymentCardTransferEntry_tx\n  ...TransferReceivedEntry_tx\n  ...TransferSentEntry_tx\n  ...TransferSentReversalEntry_tx\n  ...TransferReceivedReversalEntry_tx\n  ...PayoutTransferEntry_tx\n  ...PurchaseEntry_tx\n  ...RemittanceTransferReceivedEntry_tx\n  ...RemittanceTransferReversalEntry_tx\n  ...AdjustmentEntry_tx\n  ...LoginLogoutEvent_tx\n  ...FailedMerchantTransferEntry_tx\n  ...ReversalDisputeEntry_tx\n}\n\nfragment PurchaseEntry_tx on PurchaseEntry {\n  senderMobile\n  maybeTerminatedSenderMobile\n  amount\n  merchantId\n  merchantName\n  merchantCode\n  merchantMobile\n  promoUsed\n  transferId\n  isRefunded\n  isRemote\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n  ...RefundPurchaseEntry_transfer\n}\n\nfragment RefundP2P_transfer on MobileTransferEntry {\n  __isMobileTransferEntry: __typename\n  id\n  transferId\n  sendAmount\n  receiveAmount\n  senderName\n  senderMobile\n  recipientName\n  maybeTerminatedRecipientMobile\n}\n\nfragment RefundPurchaseEntry_transfer on PurchaseEntry {\n  id\n  transferId\n  amount\n  merchantName\n}\n\nfragment RemittanceTransferReceivedEntry_tx on RemittanceTransferReceivedEntry {\n  id\n  opaqueId\n  description\n  amount\n  isPending\n  isCancelled\n  senderName\n  senderMobile\n  senderCountry\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n  ...RemittanceTransferRefund_transfer\n  ...ChangeRemittanceRecipient_transfer\n}\n\nfragment RemittanceTransferRefund_transfer on RemittanceTransferReceivedEntry {\n  opaqueId\n  senderName\n  senderMobile\n  amount\n}\n\nfragment RemittanceTransferReversalEntry_tx on RemittanceTransferReversalEntry {\n  id\n  opaqueId\n  description\n  amount\n  isPending\n  senderName\n  senderMobile\n  senderCountry\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n}\n\nfragment ReversalDisputeEntry_tx on ReversalDisputeEntry {\n  __typename\n  description\n  isPending\n  ledgerTransactionId\n  originalTransferId\n  ...HistoryEntry_entry\n}\n\nfragment SupportPayoutTransferReverse_transfer on PayoutTransferEntry {\n  tcid\n  amount\n  senderOpaqueId\n  sender: senderName\n  maybeRecipientName: recipientName\n  recipientMobile\n  isReversal\n}\n\nfragment TransferReceivedEntry_tx on TransferReceivedEntry {\n  transferId\n  senderName\n  senderMobile\n  maybeTerminatedSenderMobile\n  paymentBatchId\n  recipientMobile\n  receiveAmount\n  ...HistoryEntry_entry\n  ...ChangeRecipient_transfer\n  ...RefundP2P_transfer\n}\n\nfragment TransferReceivedReversalEntry_tx on TransferReceivedReversalEntry {\n  transferId\n  description\n  isPending\n  isFreezingFunds\n  ledgerTransactionId\n  senderMobile\n  sendAmount\n  recipientMobile\n  ...HistoryEntry_entry\n}\n\nfragment TransferSentEntry_tx on TransferSentEntry {\n  transferId\n  senderMobile\n  recipientName\n  recipientMobile\n  maybeTerminatedRecipientMobile\n  amount\n  receiveAmount\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...ChangeRecipient_transfer\n  ...RefundP2P_transfer\n  ...BlockRecipient_transfer\n  ...HistoryEntry_entry\n}\n\nfragment TransferSentReversalEntry_tx on TransferSentReversalEntry {\n  transferId\n  description\n  isPending\n  isFreezingFunds\n  ledgerTransactionId\n  senderMobile\n  sendAmount\n  ...HistoryEntry_entry\n}\n\nfragment UserAtxEntry_tx on AgentTransactionEntry {\n  agentTransactionId\n  isDeposit\n  agentName\n  agentId\n  agentUfid\n  customerMobile\n  customerName\n  maybeTerminatedCustomerMobile\n  amount\n  relatedTicket {\n    whenOpened\n    whenResolved\n    status\n    slackMessageUrl\n    ticketType\n    reference\n  }\n  scamReports {\n    whenOpened\n    whenResolved\n    status\n    transactionIds\n  }\n  ...HistoryEntry_entry\n}\n\nfragment UserLinkedAccountTransferB2WEntry_tx on UserLinkedAccountTransferB2WEntry {\n  summary\n  isCancelled\n  partnerName\n  liaTransferId\n  errorCode\n  errorMessage\n  ...HistoryEntry_entry\n}\n\nfragment UserLinkedAccountTransferW2BEntry_tx on UserLinkedAccountTransferW2BEntry {\n  summary\n  isCancelled\n  partnerName\n  liaTransferId\n  errorCode\n  errorMessage\n  ...HistoryEntry_entry\n}\n"
  }
};
})();
(node as any).hash = '46b6f655fc20957f9f12b225a746a0a7';
export default node;
